module.exports = __webpack_public_path__ + "src/assets/textures/env/dirt_outer/dirt_outer_4K_bake.png";